import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import authService from "./services/authService";

import VuetifyConfirm from "vuetify-confirm";

import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.css";

import faker from "faker";
import lodash from "lodash";
import moment from "moment";

import "nprogress/nprogress.css";
import "@/assets/css/styles.css";

import { helpers } from "@/mixins/mixin-helpers";

import { Plugins } from "capacitor";
// const { SplashScreen } = Plugins;

//IMPORT CUSTOM COMPONENTS
import CustomDatePicker from "./components/CustomDatePicker.vue";

//IMPORT LAYOUTS
import CleanLayout from "./layouts/CleanLayout.vue";
import CashLayout from "./layouts/CashLayout.vue";
import BlankLayout from "./layouts/BlankLayout.vue";

Vue.mixin(helpers);
Vue.component("clean-layout", CleanLayout);
Vue.component("cash-layout", CashLayout);
Vue.component("blank-layout", BlankLayout);

Vue.component("custom-date-picker", CustomDatePicker);

Vue.use(VuetifyConfirm, { vuetify });
Vue.use(VuetifyDialog, {
  context: {
    vuetify,
  },
});

Object.defineProperty(Vue.prototype, "$faker", { value: faker });
Object.defineProperty(Vue.prototype, "$moment", { value: moment });
Object.defineProperty(Vue.prototype, "_", { value: lodash });

Vue.config.productionTip = false;

var _ = lodash;
router.beforeEach((to, from, next) => {
  // console.log("ROUTER REPORT:", next);
  if (_.get(to, "meta.requiresAuth", null) === true) {
    //PAGE REQUIRES "LOGGED IN" STATUS
    if (authService.isAuthenticated()) {
      next();
    } else {
      next("/login");
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  // console.log("AFTER ROUTER:", to);
  store.commit("activity/setCurrentPageName", to.name);
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  methods: {
    setBusy(busyId, busyMsg) {
      this.$store.dispatch("activity/setBusy", { busyId: busyId, busyMsg: busyMsg });
    },
    removeBusy(busyId) {
      this.$store.dispatch("activity/removeBusy", { busyId: busyId });
    },
    clearAllBusy() {
      this.$store.dispatch("activity/clearAllBusy");
    },
    systemIsBusy() {
      return this.$store.getters["activity/systemIsBusy"];
    },
  },
  beforeMount() {},
  mounted() {
    // this.$store.dispatch("cashmanagement/GENERATE_CASH_ENTITIES");
  },
}).$mount("#app");
